import { useMutation } from '@apollo/react-hooks';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { ArticleViewedMutation } from '../../api/mutations/articleViewed.gql';
import useScrollPosition from '../../hooks/useScrollPosition';

const ArticleViewed = ({ id, threshold, type }) => {
  const [articleViewed, result] = useMutation(ArticleViewedMutation);

  const { percentageY } = useScrollPosition('window');
  const thresholdReached = percentageY >= threshold;
  const dataArticleViewed = get(result.data, 'articleViewed');
  const sendMutation =
    thresholdReached && !result.loading && !dataArticleViewed;

  useEffect(() => {
    if (sendMutation) {
      articleViewed({ variables: { id, type } });
    }
  }, [articleViewed, id, sendMutation, thresholdReached, type]);

  return null;
};

ArticleViewed.propTypes = {
  id: PropTypes.string.isRequired,
  threshold: PropTypes.number.isRequired,
};

export default ArticleViewed;
